import { useState } from "react";
import styles from "./AddIncidentModal.module.css";
import { PointColor } from "../../types";

interface AddMarkerModalProps {
    coords: [number, number];
    onClose: () => void;
}

export default function AddIncidentModal({
    coords,
    onClose,
}: AddMarkerModalProps) {
    const [text, setText] = useState("");
    const [, setColor] = useState<PointColor>("green");


    const handleSave = () => {
        setText("");
        setColor("green");
        onClose();
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <h3 className={styles.modalTitle}>Добавить инцидент</h3>
                    <button className={styles.modalClose} onClick={onClose}>
                        ×
                    </button>
                </div>

                <div className={styles.modalBody}>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Координаты</div>
                        <div className={styles.modalCoords}>
                            {coords[0].toFixed(6)}, {coords[1].toFixed(6)}
                        </div>
                    </div>

                    {/* <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Загруженность</div>
                        <div className={styles.colorOptions}>
                            <label className={styles.colorOption}>
                                <input
                                    type="radio"
                                    name="color"
                                    value="green"
                                    checked={color === "green"}
                                    onChange={e => setColor(e.target.value as PointColor)}
                                />
                                <span className={`${styles.colorIndicator} ${styles.green}`}></span>
                                <span className={styles.colorLabel}>Пустая</span>
                            </label>
                            <label className={styles.colorOption}>
                                <input
                                    type="radio"
                                    name="color"
                                    value="orange"
                                    checked={color === "orange"}
                                    onChange={e => setColor(e.target.value as PointColor)}
                                />
                                <span className={`${styles.colorIndicator} ${styles.orange}`}></span>
                                <span className={styles.colorLabel}>Скоро заполнится</span>
                            </label>
                            <label className={styles.colorOption}>
                                <input
                                    type="radio"
                                    name="color"
                                    value="red"
                                    checked={color === "red"}
                                    onChange={e => setColor(e.target.value as PointColor)}
                                />
                                <span className={`${styles.colorIndicator} ${styles.red}`}></span>
                                <span className={styles.colorLabel}>Критическая</span>
                            </label>
                        </div>
                    </div> */}

                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Описание</div>
                        <textarea
                            className={styles.modalTextarea}
                            value={text}
                            onChange={e => setText(e.target.value)}
                        />
                    </div>
                </div>

                <div className={styles.modalFooter}>
                    <button className={styles.modalButton} onClick={onClose}>
                        Отмена
                    </button>
                    <button
                        className={`${styles.modalButton} ${styles.modalButtonPrimary}`}
                        onClick={handleSave}
                    >
                        Сохранить
                    </button>
                </div>
            </div>
        </div>
    );
}

